import config from './configuration.default'

// 优先使用window 下的通过scripts 加载的属性
// 其次使用本地的env 配置信息
// 最后使用default configuration
// todo 单例模式，加载后即固定内容
// todo 对内容进行校验
// eslint-disable-next-line no-undef
const cubeApp = typeof CUBE_APP !== 'undefined' ? CUBE_APP : {}
export const CUBE = Object.assign(
  config,
  {
    im: { appid: process.env.IM_APP_ID },
    publicPath: process.env.NODE_ENV === 'production' ? '/webchat' : ''
  },
  cubeApp
)



// WEBPACK FOOTER //
// ./src/configuration.js